export const isVerigramActive = (): boolean => {
  return process.env.VUE_APP_BASE_VERIGRAM_ON === 'true';
};
